import GetCareersDTO from 'wwg-utilities/dist/dtos/get-careers.dto';
import apiClient from './axiosClient';

const getNumberOfCareerResultsRequest = async (
  params: GetCareersDTO = { catalog: 'all' },
): Promise<number> => {
  return apiClient
    .get(`careers/number-of-results`, { params })
    .then((res) => res.data);
};

export default getNumberOfCareerResultsRequest;
